import { GetStaticPropsResult } from 'next';

import { getRutilusGraphqlClient } from '../../src/api/graphql/getRutilusGraphqlClient';
import { queryRutilusStatic } from '../../src/api/graphql/queryRutilusStatic';
import { AppLogic } from '../../src/components/AppLogic/AppLogic';
import { buildStateDataWaters } from '../../src/components/FindUSFishingSpot/helpers/buildStateDataWaters';
import { GlobalLayout } from '../../src/components/Layouts/GlobalLayout';
import { DISCOVER_PAGES_NAV_LINKS } from '../../src/constants/constants';
import { buildUSWaterTypeList } from '../../src/constants/fishingWaters/helpers';
import TOP_SIX_WATERS_BY_STATE from '../../src/constants/fishingWaters/top6waters_by_states_23042024.json';
import TOP_20_LAKES_IN_US from '../../src/constants/fishingWaters/top_20_lake_or_pond_waters_in_US.json';
import TOP_20_OCEANS_IN_US from '../../src/constants/fishingWaters/top_20_ocean_waters_in_US.json';
import TOP_20_RIVERS_IN_US from '../../src/constants/fishingWaters/top_20_river_or_stream_waters_in_US.json';
import { REVALIDATE } from '../../src/constants/next';
import { DEFAULT_US_STATE, US_STATES } from '../../src/constants/USstates/states';
import { GetMostActiveWaters } from '../../src/interfaces/graphql';
import { IPageMetadata } from '../../src/interfaces/nextjs';
import { getMostActiveWaters } from '../../src/queries/rutilus/Statistics';
import { Discover, IDiscoverProps } from '../../src/views/Discover/Discover';

export async function getStaticProps(): Promise<
  GetStaticPropsResult<IPageMetadata & IDiscoverProps>
> {
  const client = getRutilusGraphqlClient({ serverMode: 'static' });
  const { response } = await queryRutilusStatic<GetMostActiveWaters>(client, {
    query: getMostActiveWaters,
  });
  const stateWaterData = buildStateDataWaters(TOP_SIX_WATERS_BY_STATE);
  const lastWeekWaters = response ? response.data.statistics.mostActiveWatersLastWeek : [];
  const top20oceansInUS = buildUSWaterTypeList(TOP_20_OCEANS_IN_US);
  const top20riversInUS = buildUSWaterTypeList(TOP_20_RIVERS_IN_US);
  const top20lakesInUS = buildUSWaterTypeList(TOP_20_LAKES_IN_US);
  return {
    props: {
      _page: 'discover',
      _pageTitle: 'Discover',
      lastWeekWaters,
      stateWaterData,
      usStates: US_STATES,
      defaultUSState: DEFAULT_US_STATE,
      top20riversInUS,
      top20oceansInUS,
      top20lakesInUS,
    },
    revalidate: REVALIDATE.DAILY,
  };
}

Discover.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout siteSubNavigationLinks={DISCOVER_PAGES_NAV_LINKS}>{page}</GlobalLayout>
    </AppLogic>
  );
};

export default Discover;
